import { createRouter, createWebHashHistory } from 'vue-router'
import LoginPage from '../components/Login.vue'
import RegisterPage from '../components/Register.vue'
import ResetPasswordPage from '../components/ResetPassword.vue'
import CarListPage from '../components/CarList.vue'

const routes = [
  {
    path: '/',
    redirect: '/carlist'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/resetpwd',
    name: 'ResetPassword',
    component: ResetPasswordPage
  },
  {
    path: '/carlist',
    name: 'CarList',
    component: CarListPage
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/carlist'
  }
]

const router = createRouter({
  history: createWebHashHistory('/pastel/'),
  routes
})

export default router

